<template>
  <v-col>
    <v-tabs v-model="tab">
      <v-tab>Custom Grouptags</v-tab>
      <v-tab>RM Grouptags</v-tab>
      <v-tab>Subtypes</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <data-source-table
          ref="dataSourceRef"
          item-controller="grouptags"
          item-identify-field="name"
          :headers="headers"
          :options.sync="options"
          :selected-items.sync="selectedAd"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <confirm-dialog
                :is-open.sync="dialogs.addGroupTag.isOpened"
                confirm-button-text="save"
                :is-disable-confirm-button="!isNewGroupTagEnoughData"
                @confirm="addGrouptag"
              >
                <template v-slot:activator>
                  <v-btn
                    class="mx-2"
                    color="primary"
                    dark
                    fab
                    small
                    @click="openDialog('addGroupTag')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <slot>
                          <v-icon
                            v-bind="attrs"
                            dark
                            v-on="on"
                          >
                            mdi-plus
                          </v-icon>
                        </slot>
                      </template>
                      create new GroupTag
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  <span class="headline">GroupTag</span>
                </template>
                <template v-slot:body>
                  <v-text-field
                    v-model="dialogs.addGroupTag.data.name"
                    label="Name"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    v-model="dialogs.addGroupTag.data.dict_term_id"
                    type="number"
                    label="Term id"
                    :rules="[rules.required]"
                  />
                </template>
              </confirm-dialog>
            </v-toolbar>
          </template>
        </data-source-table>
      </v-tab-item>

      <v-tab-item>
        <div>RM Grouptags will develop in the future</div>
      </v-tab-item>

      <v-tab-item>
        <data-source-table
            ref="dataSourceSubtypeRef"
            item-controller="subtypes"
            item-identify-field="name"
            :headers="headersSubtypes"
            :options.sync="optionsSubtypes"
            :selected-items.sync="selectedAdSubtypes"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <confirm-dialog
                  :is-open.sync="dialogs.addSubtype.isOpened"
                  confirm-button-text="save"
                  :is-disable-confirm-button="!isNewSubtypeEnoughData"
                  @confirm="addSubtype"
              >
                <template v-slot:activator>
                  <v-btn
                      class="mx-2"
                      color="primary"
                      dark
                      fab
                      small
                      @click="openDialog('addSubtype')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <slot>
                          <v-icon
                              v-bind="attrs"
                              dark
                              v-on="on"
                          >
                            mdi-plus
                          </v-icon>
                        </slot>
                      </template>
                      create new Subtype
                    </v-tooltip>
                  </v-btn>
                </template>
                <template v-slot:title>
                  <span class="headline">Subtype</span>
                </template>
                <template v-slot:body>
                  <v-text-field
                      v-model="dialogs.addSubtype.data.name"
                      label="Name"
                      :rules="[rules.required]"
                  />
                </template>
              </confirm-dialog>
            </v-toolbar>
          </template>
        </data-source-table>
      </v-tab-item>
    </v-tabs-items>
  </v-col>
</template>

<script>

import DataSourceTable from '@/components/DataSource/DataTable.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '@/mixins/manageDialogsMixin';

export default {
  name: 'Grouptags',
  components: { ConfirmDialog, DataSourceTable },

  mixins: [
    manageDialogsMixin,
  ],
  data: () => ({
    tab: null,
    selectedAd: [],
    options: {
      filters: {},
    },
    rules: {
      required: (v) => (!!v) || 'Field is required',
    },
    selectedAdSubtypes: [],
    optionsSubtypes: {
      filters: {},
    },

    dialogs: {
      addGroupTag: {
        isOpened: false,
        data: {
          name: '',
          dict_term_id: null,
        },
        defaults: {
          name: '',
          dict_term_id: null,
        },
      },
      addSubtype: {
        isOpened: false,
        data: {
          name: '',
        },
        defaults: {
          name: '',
        },
      },
    },
  }),

  computed: {
    headers() {
      return [
        {
          text: 'grouptag id',
          value: 'id',
        },
        {
          text: 'grouptag name',
          value: 'name',
          edit: { type: 'text' },
        },
        {
          text: 'Term id',
          value: 'dict_term_id',
          edit: { type: 'number' },
        },
        {
          text: 'Geotag count',
          value: 'geotag_count',
          filter: { type: 'disable' },
          sortable: false,
        },
        {
          text: 'Customer count',
          value: 'customer_count',
          filter: { type: 'disable' },
          sortable: false,
        },
        {
          text: '',
          value: 'deleteItem',
          sortable: false,
          width: '80px',
        },
      ];
    },

    isNewGroupTagEnoughData() {
      return this.dialogs.addGroupTag.data.name
        && this.dialogs.addGroupTag.data.dict_term_id;
    },

    headersSubtypes() {
      return [
        {
          text: 'id',
          value: 'id',
        },
        {
          text: 'Subtype name',
          value: 'name',
          edit: { type: 'text' },
        },
        {
          text: '',
          value: 'deleteItem',
          sortable: false,
          width: '80px',
        },
      ];
    },

    isNewSubtypeEnoughData() {
      return this.dialogs.addSubtype.data.name;
    },
  },

  created() {
  },

  methods: {
    addGrouptag() {
      this.$refs.dataSourceRef.saveNew(this.dialogs.addGroupTag.data)
        .finally(() => {
          this.closeDialog('addGroupTag');
        });
    },

    addSubtype() {
      this.$refs.dataSourceSubtypeRef.saveNew(this.dialogs.addSubtype.data)
        .finally(() => {
          this.closeDialog('addSubtype');
        });
    },
  },
};
</script>
